import { StateModel } from 'src/shared/models';
import {
  GET_DYNAMIC_ADMIN_USER_TAGS,
  GET_DYNAMIC_ADMIN_USER_TAGS_ERROR,
  GET_DYNAMIC_ADMIN_USER_TAGS_SUCCESS,
} from '../actions/dynamic-admin-user-tags.action';

const INITIAL_STATE: StateModel = {
  loading: false,
  loaded: false,
  error: null,
  data: {},
};

export const dynamicAdminUserTagsReducer = (
  state: StateModel = INITIAL_STATE,
  { type, payload, error }: any,
) => {
  switch (type) {
    case GET_DYNAMIC_ADMIN_USER_TAGS:
      return {
        ...state,
        loaded: false,
        loading: true,
      };
    case GET_DYNAMIC_ADMIN_USER_TAGS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: payload.content,
      };
    case GET_DYNAMIC_ADMIN_USER_TAGS_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error,
      };

    default:
      return state;
  }
};

export default dynamicAdminUserTagsReducer;
